var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLine = function SvgLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 18c4.125 0 7.06-2.592 8.777-4.751a1.968 1.968 0 0 0 0-2.498C19.06 8.592 16.125 6 12 6c-4.126 0-7.06 2.592-8.777 4.751a1.968 1.968 0 0 0 0 2.498C4.94 15.408 7.874 18 12 18Zm10.342-3.506a3.967 3.967 0 0 0 0-4.988C20.474 7.158 17.026 4 12 4 6.973 4 3.526 7.158 1.658 9.506a3.967 3.967 0 0 0 0 4.988C3.526 16.842 6.973 20 12 20c5.026 0 8.474-3.158 10.342-5.506Z",
    fill: "#777E91"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 12a2 2 0 1 1-3.998-.085A1.5 1.5 0 0 0 12 10.5a1.5 1.5 0 0 0-.085-.498L12 10a2 2 0 0 1 2 2Zm2 0a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z",
    fill: "#777E91"
  })));
};
export default SvgLine;